import Login from '@/views/Login';
import PasswordEmail from '@/views/PasswordEmail';
import PasswordReset from '@/views/PasswordReset';
import PasswordSet from '@/views/PasswordSet';

export default [
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: { disallowAuthed: true },
    },

    {
        path: '/password/email',
        name: 'password-email',
        component: PasswordEmail,
        meta: { disallowAuthed: true },
    },
    {
        path: '/password/reset',
        name: 'password-reset',
        component: PasswordReset,
        meta: { disallowAuthed: true },
    },
    {
        path: '/password/set',
        name: 'password-set',
        component: PasswordSet,
        meta: { disallowAuthed: true },
    },
];
